import React from 'react';

export function SuccessCheck () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60"
    >
      <path
        stroke="#4FADA6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M30 57.857c15.385 0 27.857-12.472 27.857-27.857S45.385 2.143 30 2.143 2.143 14.615 2.143 30 14.615 57.857 30 57.857z"
      />
      <path
        stroke="#4FADA6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M21 30.666L26.538 36 39 24"
      />
    </svg>
  );
}
